// extracted by mini-css-extract-plugin
export var component = "SectionDogList-module--component--f1a06";
export var listbreak = "SectionDogList-module--listbreak--467e7";
export var loadingbar = "SectionDogList-module--loadingbar--6a03c";
export var loadingbarfiller = "SectionDogList-module--loadingbarfiller--3422d";
export var loadingicon = "SectionDogList-module--loadingicon--6c931";
export var loadingoverlay = "SectionDogList-module--loadingoverlay--1643c";
export var showmorebutton = "SectionDogList-module--showmorebutton--72619";
export var viewmoretext = "SectionDogList-module--viewmoretext--d494c";
export var viewmorewrapper = "SectionDogList-module--viewmorewrapper--776a5";